import {integritySettings} from 'constants/url';
import useLoad from 'components/hooks/useLoad';

function useIntegritySettings(settingId?: number | null) {
  const idValue = settingId ?? 0;
  return useLoad(
    integritySettings,
    'revision',
    {values: idValue},
    false,
    false,
    false,
  );
}

export default useIntegritySettings;
